export default __webpack_public_path__ + "static/media/check-magistal.6de44426.png";